import { graphql } from 'react-relay';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isNotFoundError } from '@confluence/error-boundary/entry-points/isNotFoundError.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';

import type { usePremiumGatePremiumGateQuery as usePremiumGatePremiumGateQuery$data } from './__types__/usePremiumGatePremiumGateQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const usePremiumGate = (): boolean => {
	const { edition } = useSessionData();
	const canSkipEntitlementCheck = edition === ConfluenceEdition.PREMIUM;
	const { data, error } = useQueryInterop<usePremiumGatePremiumGateQuery$data>(
		graphql`
			query usePremiumGatePremiumGateQuery {
				entitlements {
					premiumExtensions {
						isEntitled
					}
				}
			}
		`,
		{
			skip: canSkipEntitlementCheck,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.MIGRATIONS_TOOLING,
			});
		}
		markErrorAsHandled(error);
	}

	return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
